import { render, staticRenderFns } from "./MilitaryFamilyApply.vue?vue&type=template&id=f060f310"
import script from "./MilitaryFamilyApply.vue?vue&type=script&lang=js"
export * from "./MilitaryFamilyApply.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports